import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';

interface IERdvBreadcrumbWidgetProps {
    title: string;
    formStep: number;
    dictSteps: string[];
    handleNavTo: (val: number) => void;
    hideFirstStep: boolean;
    resetEnabled: boolean;
}

export class ERdvBreadcrumbWidget extends Component<IERdvBreadcrumbWidgetProps> {
    public myRef: React.RefObject<HTMLDivElement>;

    constructor(props: IERdvBreadcrumbWidgetProps) {
        super(props);
        this.state = {};
        this.myRef = React.createRef();
    }

    render() {
        let mobile = false;
        if (this.myRef.current && this.myRef.current.offsetWidth < 550) {
            mobile = true;
        }

        const bgGrey = {
            backgroundColor: '#f3f4f4',
        } as React.CSSProperties;

        const yellowCircle = {
            borderRadius: '100%',
            backgroundColor: '#FFE123',
            width: '25px',
            height: '25px',
            cursor: 'pointer',
        } as React.CSSProperties;

        const whiteCircle = {
            borderRadius: '100%',
            backgroundColor: 'white',
            width: '25px',
            height: '25px',
        } as React.CSSProperties;

        const yellowLine = {
            borderTop: 'solid 4px #FFE123',
            top: '11px',
            left: '50%',
            width: '100%',
        } as React.CSSProperties;

        const whiteLine = {
            borderTop: 'solid 4px white',
            top: '11px',
            left: '50%',
            width: '100%',
        } as React.CSSProperties;

        const aLink = {
            cursor: 'pointer',
        } as React.CSSProperties;

        const fontSize = {
            fontSize: 'clamp(8px, 3vw, 16px)',
        } as React.CSSProperties;

        const maxWidthVal =
            100 /
                (this.props.dictSteps.length -
                    (this.props.hideFirstStep ? 1 : 0)) +
            '%';
        const maxW = {
            maxWidth: maxWidthVal,
        } as React.CSSProperties;

        return (
            <div className="container-max w-100" style={bgGrey}>
                <div className="row">
                    <div className="offset-lg-3 col-lg-6" ref={this.myRef}>
                        <div className="row">
                            <div className="col-12 text-center">
                                <h1 className="h1">{this.props.title}</h1>
                            </div>
                        </div>
                        {!mobile && (
                            <div className="row">
                                <div className="d-flex w-100">
                                    {this.props.dictSteps.map(
                                        (value, index) => {
                                            const indexId = 'step' + index;
                                            let className =
                                                'flex-grow-1 position-relative';
                                            if (index === 0) {
                                                className += ' pl-4';
                                            }
                                            if (
                                                index ===
                                                this.props.dictSteps.length - 1
                                            ) {
                                                className += ' pr-4';
                                            }
                                            return (
                                                <div
                                                    className={className}
                                                    key={index}
                                                    style={maxW}
                                                    id={indexId}
                                                    hidden={
                                                        this.props
                                                            .hideFirstStep &&
                                                        index === 0
                                                    }
                                                >
                                                    <div className="row ml-0 my-4 w-100 position-relative">
                                                        {index <
                                                            this.props
                                                                .formStep && (
                                                            <div
                                                                className="position-absolute"
                                                                style={
                                                                    yellowLine
                                                                }
                                                            ></div>
                                                        )}
                                                        {index >=
                                                            this.props
                                                                .formStep &&
                                                            index + 1 !==
                                                                this.props
                                                                    .dictSteps
                                                                    .length && (
                                                                <div
                                                                    className="position-absolute"
                                                                    style={
                                                                        whiteLine
                                                                    }
                                                                ></div>
                                                            )}
                                                        <div className="col-12 text-center">
                                                            {index <=
                                                                this.props
                                                                    .formStep && (
                                                                <div
                                                                    className="p-100 d-inline-block"
                                                                    style={
                                                                        yellowCircle
                                                                    }
                                                                    onClick={() =>
                                                                        this.props.handleNavTo(
                                                                            this
                                                                                .props
                                                                                .resetEnabled
                                                                                ? this
                                                                                      .props
                                                                                      .hideFirstStep
                                                                                    ? 1
                                                                                    : 0
                                                                                : index
                                                                        )
                                                                    }
                                                                ></div>
                                                            )}
                                                            {index >
                                                                this.props
                                                                    .formStep && (
                                                                <div
                                                                    className="p-100 d-inline-block"
                                                                    style={
                                                                        whiteCircle
                                                                    }
                                                                ></div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="row my-4">
                                                        <div className="col-12 text-center">
                                                            {index <=
                                                                this.props
                                                                    .formStep && (
                                                                <div
                                                                    className=""
                                                                    style={
                                                                        aLink
                                                                    }
                                                                    onClick={() =>
                                                                        this.props.handleNavTo(
                                                                            this
                                                                                .props
                                                                                .resetEnabled
                                                                                ? this
                                                                                      .props
                                                                                      .hideFirstStep
                                                                                    ? 1
                                                                                    : 0
                                                                                : index
                                                                        )
                                                                    }
                                                                >
                                                                    <span
                                                                        style={
                                                                            fontSize
                                                                        }
                                                                    >
                                                                        {value}
                                                                    </span>
                                                                </div>
                                                            )}
                                                            {index >
                                                                this.props
                                                                    .formStep && (
                                                                <div className="">
                                                                    <span
                                                                        style={
                                                                            fontSize
                                                                        }
                                                                    >
                                                                        {value}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    )}
                                </div>
                            </div>
                        )}
                        {mobile && (
                            <div className="row pb-5">
                                {this.props.dictSteps.map((value, index) => {
                                    const indexId = 'step' + index;

                                    return (
                                        <div
                                            className="offset-1 col-10"
                                            key={indexId}
                                        >
                                            <div className="row w-100 my-2">
                                                <div className="d-flex justify-content-start">
                                                    {index <=
                                                        this.props.formStep && (
                                                        <div
                                                            className="p-100 mr-4"
                                                            style={yellowCircle}
                                                            onClick={() =>
                                                                this.props.handleNavTo(
                                                                    this.props
                                                                        .resetEnabled
                                                                        ? this
                                                                              .props
                                                                              .hideFirstStep
                                                                            ? 1
                                                                            : 0
                                                                        : index
                                                                )
                                                            }
                                                        ></div>
                                                    )}
                                                    {index >
                                                        this.props.formStep && (
                                                        <div
                                                            className="p-100 mr-4"
                                                            style={whiteCircle}
                                                        ></div>
                                                    )}

                                                    {index <=
                                                        this.props.formStep && (
                                                        <div
                                                            style={aLink}
                                                            onClick={() =>
                                                                this.props.handleNavTo(
                                                                    this.props
                                                                        .resetEnabled
                                                                        ? this
                                                                              .props
                                                                              .hideFirstStep
                                                                            ? 1
                                                                            : 0
                                                                        : index
                                                                )
                                                            }
                                                        >
                                                            <span>{value}</span>
                                                        </div>
                                                    )}
                                                    {index >
                                                        this.props.formStep && (
                                                        <div>
                                                            <span>{value}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

WidgetHelper.register(ERdvBreadcrumbWidget, 'erdv-breadcrumb-widget');
